import {
    CONTENT_SEARCH_REQUEST,
    CONTENT_SEARCH_SUCCESS,
    CONTENT_SEARCH_FAILURE,
  } from '../../../Constants/actionTypes';
  
  import { content_search } from '../../../Constants/apiService'
  
  
  // Action to start search
  export const contentSearchRequest = () => ({
    type: CONTENT_SEARCH_REQUEST,
  });
  
  // Action when search is successful
  export const contentSearchSuccess = (results) => ({
    type: CONTENT_SEARCH_SUCCESS,
    payload: results,
  });
  
  // Action when search fails
  export const contentSearchFailure = (error) => ({
    type: CONTENT_SEARCH_FAILURE,
    payload: error,
  });
  
  
  export const contentSearch = (query) => {
    return async (dispatch, getState) => {
      dispatch(contentSearchRequest());
  
      const state = getState();
      const accessToken = state.auth.accessToken;
  
      try {
  
        const data = await content_search(accessToken, query);
        console.log(data)
        dispatch(contentSearchSuccess(data));
  
      } catch (error) {
        let errorMessage;
        if (error.message === 'Failed to fetch' || error.message.includes('NetworkError')) {
          errorMessage = 'Server is currently down. Please try again later.';
        } else {
          errorMessage = error.message;
        }
        dispatch(contentSearchFailure(errorMessage));
      }
  
  
    };
  };